import { IsNotEmpty } from "class-validator";


export class CustomerWorkoutCreateSetFormData {
    @IsNotEmpty()
    exerciseUuid: string;

    @IsNotEmpty()
    exerciseName: string;

    @IsNotEmpty()
    exerciseGroup: string;

    @IsNotEmpty()
    uuid: string;

    @IsNotEmpty()
    weight: string;
    
    @IsNotEmpty()
    reps: string;

    @IsNotEmpty()
    editWeight: string;
    
    @IsNotEmpty()
    editReps: string;
    
}
